import React from 'react';
import styled from 'styled-components';
import { theme } from '../styles/theme';




// Styled Components
const ProfileContainer = styled.div`
    position: relative;
    display: inline-block;
    width: 32px;
    height: 32px;

`;

const ProfileImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
`;

const NotificationBadge = styled.div<{ count: number }>`
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: ${theme.colors.gray[200]};
  border: 1px solid ${theme.colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${theme.fonts.primary};
  font-weight: ${theme.fontWeights.bold};
  font-size: 8px;
  color: ${theme.colors.black};
  position: absolute;
  top: 18px;
  left: 22px;

  &>div{
    position: relative;
  }
`;

// Component Props Interface
interface ProfileBadgeProps {
  imageUrl: string;
  notificationCount?: number;
  alt?: string;
  onClick?: () => void;
}

const ProfileBadge: React.FC<ProfileBadgeProps> = ({
  imageUrl,
  notificationCount = 0,
  alt = "Profile Picture",
  onClick
}) => {
  return (
    <ProfileContainer onClick={onClick}>
      <ProfileImage src={imageUrl} alt={alt} />
      {notificationCount > 0 && (
        <NotificationBadge count={notificationCount}>
          <div>{notificationCount > 9 ? '9+' : notificationCount}</div>
        </NotificationBadge>
      )}
    </ProfileContainer>
  );
};

export default ProfileBadge;